import gql from "graphql-tag";
import { IMember } from "@/models/Member.model";

export const register = (member: IMember, conference: string) => {
  return gql`
    mutation {
      register(
        conference:"${conference}",
        firstName:"${member.firstName}",
        lastName:"${member.lastName}",
        country:"${member.country}",
        email:"${member.email}",
        title:"${member.title}",
        gender:"${member.gender}",
        university:"${member.university}",
        password:"${member.password}")
{
 token,member{
      _id
    conference
    firstName
    lastName
    title
    gender
    university
    country
    email
    biography
    isReviewer
    isAdmin
    isSuperAdmin
          hasEditConferences
          hasEditContent
          hasEditMembers
          hasEditArticles
          hasEditAdmins
  }
        }
    }
`;
};

export const login = (member: IMember, conference: string) => {
  return gql`
      mutation {
        login(
          conference:"${conference}",
          email: "${member.email}",
          password: "${member.password}"){
         token,member{   _id
          conference
          firstName
          lastName
          title
          gender
          university
          country
          email
          biography
          link
          isReviewer
          isAdmin
          isSuperAdmin
          hasEditConferences
          hasEditContent
          hasEditMembers
          hasEditArticles
          hasEditAdmins
        }
          }
      }
  `;
};

export const adminLogin = (member: IMember, conference: string) => {
  return gql`
      mutation {
        adminLogin(
          conference:"${conference}",
          email: "${member.email}",
          password: "${member.password}"){
         token,member{   _id
          conference
          firstName
          lastName
          title
          gender
          university
          country
          email
          biography
          link
          isReviewer
          isAdmin
          isSuperAdmin
          hasEditConferences
          hasEditContent
          hasEditMembers
          hasEditArticles
          hasEditAdmins
        }
          }
      }
  `;
};

export const me = () => {
  return gql`
    query me($conference: ID) {
      me(conference: $conference) {
        _id
        conference
        firstName
        lastName
        title
        gender
        university
        country
        email
        biography
        link
        isReviewer
        isAdmin
        isSuperAdmin
        hasEditConferences
        hasEditContent
        hasEditMembers
        hasEditArticles
        hasEditAdmins
      }
    }
  `;
};

export const recover = (email: string, conference: string) => {
  return gql`
      mutation {
        recover(
          email:"${email}",
          conference:"${conference}")
      }
  `;
};

export const reset = (newPassword: string, token: string) => {
  return gql`
      mutation {
        resetPassword(
          newPassword:"${newPassword}",
          token:"${token}"){
            _id
            conference
            firstName
            lastName
            title
            university
            country
            email
            biography
            link
            isReviewer
            isAdmin
            isSuperAdmin
            hasEditConferences
            hasEditContent
            hasEditMembers
            hasEditArticles
            hasEditAdmins
        }
      }
  `;
};
